import React, { useContext, useEffect } from 'react';
import { CommonContext } from '../../../../context';
import OrderStatusTable from './OrderStatusTable';

const OrderStatus = () => {
    const { onMerchantCourier } = useContext(CommonContext)


    useEffect(() => {
        onMerchantCourier();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    return (
        <>
            <OrderStatusTable />
        </>
    );
};

export default OrderStatus;
